import { render, staticRenderFns } from "./upgrade-history-dialog.vue?vue&type=template&id=1dfabe21&scoped=true&"
import script from "./upgrade-history-dialog.vue?vue&type=script&lang=js&"
export * from "./upgrade-history-dialog.vue?vue&type=script&lang=js&"
import style0 from "./upgrade-history-dialog.vue?vue&type=style&index=0&id=1dfabe21&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfabe21",
  null
  
)

export default component.exports